import { IconName } from "icons";
import React from "react";
import {
  Archive,
  Building,
  CalendarBlank,
  DocumentPlus,
  FileDashed,
  FirstAid,
  Lifebuoy,
  Lightning,
  Bell,
  Clock,
  Dots,
  List,
  Logo,
  Note,
  Notepad,
  Plus,
  SignOut,
  Stethoscope,
  UserList,
  Wifi,
  Trash,
  Funnel,
  LinkBreak,
  User,
  CalendarX,
  CalendarStar,
  CalendarSlash,
  Images,
  PencilSimpleLine,
  MarkerCircle,
  ArrowLeft,
  ArrowRight,
  Check,
  WarningCircle,
  TrashSimple,
  Warning,
  ExclamationMark,
  DownloadSimple, FileMagnifyingGlass,
  XCircle,
  Mailbox,
  HourglassSimpleMedium, QuestionMark,
  ClockCounterClockwise, ChatCenteredText, CheckCircle, UserCheck, Copy, Printer, ArrowClockwise,
  PaperPlaneTilt
} from "./index";

type IconType = React.FC<{
  height?: number;
  width?: number;
  color?: string;
}>;

const iconMapping: Record<IconName, IconType> = {
  Archive,
  Bell,
  Building,
  CalendarBlank,
  Clock,
  DocumentPlus,
  Dots,
  FileDashed,
  FirstAid,
  Lifebuoy,
  Lightning,
  List,
  Logo,
  Note,
  Notepad,
  Plus,
  SignOut,
  Stethoscope,
  UserList,
  Wifi,
  Trash,
  Funnel,
  LinkBreak,
  User,
  CalendarX,
  CalendarStar,
  CalendarSlash,
  Images,
  PencilSimpleLine,
  MarkerCircle,
  ArrowLeft,
  ArrowRight,
  Check,
  WarningCircle,
  TrashSimple,
  Warning,
  ExclamationMark,
  DownloadSimple,
  FileMagnifyingGlass,
  XCircle,
  Mailbox,
  HourglassSimpleMedium,
  ClockCounterClockwise,
  ChatCenteredText,
  CheckCircle,
  UserCheck,
  Copy,
  Printer,
  QuestionMark,
  ArrowClockwise,
  PaperPlaneTilt
};

export default iconMapping;
